// Grid clustering untuk kapal dan landmark

// eslint-disable-next-line import/prefer-default-export
export function clusterByGrid(items, cellSize, getLatLng) {
  if (!Array.isArray(items) || items.length === 0) return [];
  const size = Number(cellSize);
  if (!(size > 0)) return [];

  const sel = new Map();
  items.forEach((item) => {
    const pos = getLatLng(item) || [];
    const lat = Number(pos[0]);
    const lng = Number(pos[1]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    const key = `${Math.floor(lat / size)}:${Math.floor(lng / size)}`;
    if (!sel.has(key)) sel.set(key, { sumLat: 0, sumLng: 0, items: [] });
    const content = sel.get(key);
    content.sumLat += lat;
    content.sumLng += lng;
    content.items.push(item);
  });

  const result = [];
  sel.forEach((content) => {
    result.push({
      lat: content.sumLat / content.items.length,
      lng: content.sumLng / content.items.length,
      items: content.items,
    });
  });
  return result;
}
